import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { CheckIcon, CloseIcon, IconFillColor, IconSize, IconWrapper, StyledFlex } from '@dreryk/react-components';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

const StyledGynecologicalInterviewBasicPregnancyInfoText = styled.span`
   text-transform: lowercase;
`;
StyledGynecologicalInterviewBasicPregnancyInfoText.displayName = 'StyledGynecologicalInterviewBasicPregnancyInfoText';

type GynecologicalInterviewBasicPregnancyInfoProps = {
   readonly confirmed: boolean;
   readonly multiple: boolean;
};

export const GynecologicalInterviewBasicPregnancyInfo = (
   props: GynecologicalInterviewBasicPregnancyInfoProps
): JSX.Element => {
   return (
      <StyledFlex justifyContent={'space-between'} alignItems={'flex-end'} flex={'0 0 245px'}>
         <StyledFlex gap={'4px'}>
            <IconWrapper
               testId={'pregnancyConfirmed'}
               size={IconSize.SMALL}
               fillColor={props.confirmed ? IconFillColor.PRIMARY : IconFillColor.ERROR}
            >
               {props.confirmed ? <CheckIcon /> : <CloseIcon />}
            </IconWrapper>
            <StyledGynecologicalInterviewBasicPregnancyInfoText>
               <Translate>
                  {
                     gynecologicalInterviewTranslationKeys[
                        props.confirmed ? 'pregnancyConfirmed' : 'pregnancyUnconfirmed'
                     ]
                  }
               </Translate>
            </StyledGynecologicalInterviewBasicPregnancyInfoText>
         </StyledFlex>
         {props.multiple ? (
            <StyledFlex gap={'4px'}>
               <IconWrapper testId={'multiplePregnancy'} size={IconSize.SMALL}>
                  <CheckIcon />
               </IconWrapper>
               <StyledGynecologicalInterviewBasicPregnancyInfoText>
                  <Translate>{gynecologicalInterviewTranslationKeys.multiplePregnancy}</Translate>
               </StyledGynecologicalInterviewBasicPregnancyInfoText>
            </StyledFlex>
         ) : null}
      </StyledFlex>
   );
};
